export default "__VITE_ASSET__NwYlf9rx__"